var _polyline, _g, _g2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInPlaylistCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    transform: "matrix(.0536 0 0 .0514 1.34 1.96)",
    points: "60 160 60 300 130 300",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0535 0 0 .0539 1.88 1.73)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.12,
    y: 10.9,
    width: 292,
    height: 149,
    fill: "none",
    strokeWidth: 11.8
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 65,
    width: 40,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 260,
    y1: 65,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 260,
    y1: 105,
    y2: 105
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0535 0 0 .0539 8.3 12)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 180,
    fill: "none",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 90,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 130,
    y2: 130
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.896 9.6432c2.5392 0 4.5976-2.0584 4.5976-4.5976s-2.0584-4.5976-4.5976-4.5976-4.5976 2.0584-4.5976 4.5976 2.0584 4.5976 4.5976 4.5976z",
    strokeWidth: 0.91953
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.461 7.2879-1.6815-1.7997c-0.23016-0.24639-0.21701-0.63621 0.02942-0.86641 0.24634-0.23021 0.63622-0.21696 0.86638 0.029397l1.2971 1.3882 2.053-1.9182c0.01848-0.017269 0.03779-0.033094 0.05775-0.047641l0.96541-0.90205c0.24643-0.2302 0.63631-0.21695 0.86647 0.029434 0.23016 0.24636 0.21692 0.63621-0.02942 0.86642l-2.9488 2.7551-0.0031-0.00337-1.02 0.95305z",
    strokeWidth: 0.91953
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInPlaylistCheck);
export default __webpack_public_path__ + "static/media/file-in-playlist-check.c68a6e89626ee5c1aea5e19c0dc3a7d3.svg";
export { ForwardRef as ReactComponent };